import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import AlgosignerUtility from "./../apis/AlgosignerUtility";
import Wallet from "./Wallet";
import { useParams } from "react-router-dom";
import Button from '@mui/material/Button';
import './ResetPassword.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {MDBContainer, MDBCol, MDBRow, MDBBtn, MDBInput, MDBCheckbox } from 'mdb-react-ui-kit';
var config = require("../../src/config/dev").default;



const ResetPassword = (props) => {
  const [setWalletAddress] = useState("");
  const [error, setError] = useState('');
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPass] = useState("");
  const [confirmpass, setconfirmPass] = useState("");
  const params = useParams();
  const userId= params;
  console.log("ID",userId);

  const handleConfirmpass = async (e) => {
    console.log("in confirmpass function")
    setconfirmPass(e.target.value)
     if (password !== confirmpass)
     setError("Password does not match");
 }

 const ResendPassword = (e) => {
    const resend_password = {
      userId : userId
      };
      console.log(resend_password);
      axios.post(config.API_ENDPOINT+"api/v1/user/resendOtpCallMarketPlace", resend_password).then((response) => {
        console.log("Res",response);

        if (response.data.success == true) {
          console.log("in if",toast.success("Email Sent Successfully!!"))
          toast.success("Email Sent Successfully!!", {
            position:'top-center',
            autoClose:3000,
            onClose: () => {window.location.reload()}
         });
          
        } else {
          
        }
      });
  
 }

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(email);
    var accessToken;
   
    /* I am adding authentication code*/

    const reset_password = {
    Id : userId,
    code: otp,
	  password: password,
	  confirmPassword: confirmpass,
    // email : "null"
    };
    console.log(reset_password);
    axios.post(config.API_ENDPOINT+"api/v1/user/resetpassword", reset_password).then((response) => {
      console.log("Res",response.data.data);
    
      
      // sessionStorage.setItem("Id", response.data.id);
      if (response.status === 200) {
        window.location.href = "/";
        // return accessToken;
        
      } else {
        console.log("in else");
        
      }
    })
    .catch((error) => {
      console.log("ERR",error);
      console.log("in catch cond");

      const msg = error?.response?.data?.errors?.[0]?.msg || error?.message || "Network error. Please try again.";
      toast.error("Error : " + msg, {
        position:'top-center',
        autoClose:3000,
        //Toastify__toast Toastify__toast-theme--light Toastify__toast--error Toastify__toast--close-on-click"
        // onClose: () => {window.location.href = config.Local_ENDPOINT+`resetpassword/`+response.data.data.result.otp.userId}
     });

    });
  };

    return (
        

<div className="container">
  {/* <div className="row">
    <div className="col"></div>
    <div className="col textlogin paddinglogin">
      <h2>LOGIN</h2>
    </div>
  </div> */}

  <div className="row">
    
      <div className="col-10 col-md-6">
        <img src={require("../images/login_nft.png")} className="img" />
      </div>
      <div className="col-10 col-md-6">

        <div className="col textlogin">
        <h2 className="h2login">RESET PASSWORD</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <MDBInput className='mb-3' value={otp} onChange={(e) => setOtp(e.target.value)} type="text" placeholder="OTP" id="otp" name="otp" size="lg" style={{ fontSize: '13px', width: '100%', marginBottom: '2px' }}/>
          <MDBInput className='mb-3' value={password} onChange={(e) => setPass(e.target.value)} type="password" placeholder="Enter Password" id="password" name="password" size="lg" required pattern= "(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" title="Password must have atleast one Special Character, One Digit , One UpperCase, One Lowercase, length should be minimum 8!" style={{ fontSize: '13px', width: '100%', marginBottom: '13px' }}/>
          <MDBInput className='mb-3' value={confirmpass} onChange={handleConfirmpass} type="password" placeholder="Confirm Password" id="confirmpass" name="confirmpass" size="lg" required pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" title="Password and Confirm Password should match" style={{ fontSize: '13px', width: '100%', marginBottom: '13px' }}/>
          <a className="buttonresend font-change" href="#" onClick={ResendPassword} style={{ fontSize: '5px', marginBottom: '10px !important' }}>Resend OTP?</a>
          <br/><br />
          <div className="d-flex justify-content-center">
          <Button className="buttonlogin font-change" type="submit">RESET PASSWORD</Button>
          <a href="/">
          <Button className="buttonlogin font-change">CANCEL</Button>
          </a>
          </div>
          <ToastContainer/>
        </form>
       
        {/* <br></br> */}
        {/* <Link to="/register" className="link-btn">
          Don't Have an Account? Sign Up!
        </Link> */}
    </div>
    
</div>

</div>
    

 
      
    )
}

export default ResetPassword;
